import { render, staticRenderFns } from "./ShoppingCartOverview.vue?vue&type=template&id=7518738c&"
import script from "./ShoppingCartOverview.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports